// extracted by mini-css-extract-plugin
export default {"container":"MeetingsTab_container__Ls2oE","segmented":"MeetingsTab_segmented__Wos2H","content":"MeetingsTab_content__ecZqC"};